import React, { Component } from 'react';
import { Container, Table, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

import { AdminNav, Loading } from '../../helpers';

import './styleTable.css';

class FinancialAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FinancialSheet: null,
      listInComplete: true,
      inCompleteLoading: false,
      completedLoading: false,
      CompanyList : null,
    };
  }

  componentWillMount() {
  }
  render() {
    return (
      <Container>
        <AdminNav />
      </Container>
    );
  }
}

export default withRouter(FinancialAccount);

